export default __webpack_public_path__ + "static/media/filling_1.f8c015f1.webp";